import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import objectivesReducer from 'containers/Objective/store/reducer';
import appReducer from 'containers/App/store/reducer';
import headerReducer from 'containers/Header/store/reducer';
import objectiveDetailsReducer from 'containers/ObjectiveActivity/store/reducer';
import userBoardReducer from 'containers/Userboard/store/reducer';
import inviteReducer from 'containers/Invite/store/reducer';
import profileReducer from 'containers/Account/store/reducer';
import appConfigReducer from './AppConfig/reducer';

const history = createBrowserHistory();

const AllRootReducers = {
  appReducer,
  headerReducer,
  objectivesReducer,
  objectiveDetailsReducer,
  userBoardReducer,
  inviteReducer,
  appConfigReducer,
  profileReducer
};

const combinedAppReducers = combineReducers({
  router: connectRouter(history),
  ...AllRootReducers
});

export { combinedAppReducers, AllRootReducers };
